import { MAIL_LEGAL_LINKS, mailLegalExternalLinkProps } from "@/lib/legal/mailLegalLinks";

/** Mention légale discrète (transparence OAuth / CGU) — bas de l’écran de connexion. */
export function MailConnectLegalNotice() {
  return (
    <p className="px-1 text-center text-[10px] leading-relaxed text-[var(--mail-muted)]">
      En connectant un compte, vous acceptez nos{" "}
      <a
        {...mailLegalExternalLinkProps(MAIL_LEGAL_LINKS.terms)}
        className="underline underline-offset-2 hover:text-[var(--mail-text)]"
      >
        conditions d&apos;utilisation
      </a>{" "}
      et notre{" "}
      <a
        {...mailLegalExternalLinkProps(MAIL_LEGAL_LINKS.privacy)}
        className="underline underline-offset-2 hover:text-[var(--mail-text)]"
      >
        politique de confidentialité
      </a>
      .
    </p>
  );
}
